import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const heroImage = 'https://cdn.magicpatterns.com/uploads/atUWghtyzcsrXcnkCqoNbq/Mockup_-_SN19.webp';
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = '';
document.head.appendChild(preconnect);
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.href = heroImage;
preload.setAttribute('fetchpriority', 'high');
document.head.appendChild(preload);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-198" data-mp="2p0bm992u3dt3" />);
}